const STORAGE_KEY = 'reception'

const SessionStorage = {
  read(key) {
    const data = sessionStorage.getItem(STORAGE_KEY)
    const values = data ? JSON.parse(data) : {}
    return key ? values[key] : values
  },

  write(key, value) {
    const values = SessionStorage.read()
    values[key] = value
    const json = JSON.stringify(values)
    sessionStorage.setItem(STORAGE_KEY, json)
  },
}

export default SessionStorage
